<template>
  <div>
      <QS-h4-title title="支付款项">
        <template slot="content">
          <el-popover  placement="right-start" width="500" trigger="hover">
            <span v-html="paymentTips"></span>
            <i slot="reference" class="el-icon-info icon-info"></i>
          </el-popover>
        </template>
        <template slot="right">支付项金额:{{ (+paymentAmountSum).toFixed(2) }}元</template>
      </QS-h4-title>
      <div class="mt16 mb16">
        <div>
          <span class="label">增加支付项：</span>
          <el-select v-model="selectPaymentVal" placeholder="请选择">
            <el-option
              v-for="item in settleMentFeeFilteredList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="addPayment">添加</el-button>
        </div>
      </div>
      <el-table
        :data="paymentList"
        height="500"
        cell-class-name="custom-cell-class"
      >
        <el-table-column prop="title" label="支付内容" width="110"></el-table-column>
        <el-table-column label="付款方" width="100">
          <!-- slot-scope="" 必须写，否则会报错 -->
          <template slot-scope="">{{ orderData.customerName }}</template>
        </el-table-column>
        <el-table-column label="支付金额（元）" width="180">
          <template slot-scope="{ row, $index }">
              <!-- 只有违约金有 切换支付方式 -->
              <div v-if="row.title === '违约金'">
                <!-- 固定金额输入框 -->
                <el-input
                  v-if="isFixed"
                  v-model="row.amount"
                  placeholder="请输入"
                  @input="(val) => moneyBlur(val, $index, true)"
                >
                  <template slot="append">元</template>
                </el-input>
                <!-- 按核算比例输入框 + 提示 -->
                <div v-else>
                  <el-input
                    v-number:percent
                    v-model="percent"
                    placeholder="请输入"
                    @input="(val) => moneyPercentBlur(val, $index)"
                  >
                    <template slot="append">%</template>
                  </el-input>
                  <div class="tips" style="padding-left: 0;">
                    <p>剩余租期租金：{{ surplusReceivableAmount || '0.00' }} 元</p>
                    <p>当前比例违约金金额：{{ row.amount || '0.00' }}元</p>
                    <p class="el-icon-info" v-show="Number(surplusReceivableAmount) === 0">&nbsp;当前租期剩余租金为0，无法按比例结算</p>
                  </div>
                </div>
                <!-- @click="isFixed = !isFixed" -->
                <el-button
                  @click="changeInputHandle($index)"
                  class="mt16"
                  type="text"
                  icon="el-icon-s-operation">
                    {{ changeBtnText }}
                </el-button>
              </div>
              <!-- 除了违约金其他行的固定金额输入框 -->
              <el-input
                v-else
                v-model="row.amount"
                placeholder="请输入"
                @input="(val) => moneyBlur(val, $index)"
              >
                <template slot="append">元</template>
              </el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="280px">
          <template slot-scope="{ row }">
            <el-input
              v-model="row.remarks"
              type="textarea"
              placeholder="请输入备注"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <UploadCommon
              :fileList="row.photos"
              :limit="3"
              :showUploadBtnByLimit="3"
              :isAlone="false"
              :isShowTitle="false"
              :sizeType="4"
              commonUpload
              group="finance"
              code="finance_pay_agreement_pic"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
        >
          <template slot-scope="{ row,$index }">
            <el-button
              type="text"
              v-if="row.isHandle"
              @click="handleDelete($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { limitMoreZero, limitMoreZeroByPercent } from '@/utils/validate'

export default {
  inject: ['settleDetail', 'orderData'],
  props: {
    surplusReceivableAmount: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      paymentTips: `<span>
                    一、需补欠款的计算 <br/>
                      a）需补欠款=支付款项+租金欠款-应退押金 <br/>
                      b）先用应退押金抵扣需补欠款，应退押金抵扣完用应退租金抵扣需补欠款，生成应收款单<br/>
                    二、应退租金的计算 <br/>
                      a）应退租金=已收租金-应收租金-需补欠款 <br/>
                    三、应退押金的计算 <br/>
                      a）应退押金=已收押金-应收租金-支付项 <br/>
                    </span>`,
      selectPaymentVal: null,
      paymentList: [],
      percent: '0.00', // 违约金 百分比
      isFixed: true, // 支付方式  固定金额: true, 按核算比例：false
      paymentAmountSum: '0.00', // 支付款项：表格所有列之和
    }
  },
  computed: {
    ...mapState({
      settleMentFeeList: (state) => state.global.settleMentFeeList, // 结算费项
    }),
    // 页面增加支付费项的枚举 需要过滤掉接口返回的几个费项目 和 1-租金、2-押金
    settleMentFeeFilteredList() {
      let na = []
      const settleMentFeeListClone = _cloneDeep(this.settleMentFeeList)
      let codeList = this.paymentList.reduce((total, i) => {
        return total.concat(i.type)
      }, [])
      codeList = codeList.concat([1, 2])
      if (codeList && codeList.length > 0) {
        na = settleMentFeeListClone.filter((item) => !codeList.includes(item.code))
      }
      return na
    },
    changeBtnText() {
      return this.isFixed ? '按比例核算' : '固定金额'
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'settlementFeeType' })
  },
  watch: {
    paymentList: {
      handler() {
        this.paymentAmountCpt()
      },
      deep: true,
    },
    settleDetail: {
      handler(val) {
        this.setData(val.orderSettlementItems)
      },
    },
  },
  methods: {
    // 添加支付项
    addPayment() {
      if (!this.selectPaymentVal) {
        this.$message.warning('请添加支付项')
        return
      }
      const label = (this.settleMentFeeList.filter((item) => item.code === this.selectPaymentVal)[0] || {}).name
      const { sort } = this.settleMentFeeList.filter((item) => item.code === this.selectPaymentVal)[0] || {}
      // 判断应收款项中是否已经添加过要添加的值
      const findPaymentVal = this.paymentList.filter((item) => item.type === this.selectPaymentVal)
      if (findPaymentVal.length !== 0) {
        this.$message.warning('请勿添加重复的支付项')
        return
      }
      const data = {
        sort,
        title: label,
        type: this.selectPaymentVal,
        amount: '0.00',
        remarks: '',
        photos: [],
        isHandle: true,
      }
      this.paymentList.push(data)
    },
    // 固定金额 input事件 计算
    moneyBlur(value, index, isDefault) {
      const self = this
      limitMoreZero(
        value,
        (res) => {
          self.paymentList[index].amount = res
          // 违约金字段才计算比例
          if (isDefault) {
            // 比例 = 违约金金额 / 剩余租期租金
            if (Number(self.surplusReceivableAmount) === 0) {
              self.percent = '0.00'
            } else {
              let num = (Number(self.paymentList[index].amount) / Number(self.surplusReceivableAmount)) * 100
              num = num > 100 ? 100 : num // 违约金金额 = 剩余租期租金 * 已输入的比例
              self.percent = num.toFixed(2)
            }
          }
        },
        7,
      )
    },
    // 按比例 input 事件 计算
    moneyPercentBlur(value, index) {
      const self = this
      limitMoreZeroByPercent(
        value,
        (res) => {
          if (Number(self.surplusReceivableAmount) === 0) {
            self.percent = '0.00'
          } else {
            self.percent = res
            // 违约金金额 = 剩余租期租金 * 已输入的比例
            self.paymentList[index].amount = (Number(self.surplusReceivableAmount) * (Number(res) / 100)).toFixed(2)
          }
        },
      )
    },
    changeInputHandle(index) {
      if (this.isFixed) {
        // 初始化比例， 在切换的时候触发
        this.moneyBlur(this.paymentList[index].amount, index, true)
      }
      this.isFixed = !this.isFixed
      if (!this.isFixed) {
        const current = Number(this.paymentList[index].amount)
        const total = Number(this.surplusReceivableAmount)
        if (current > total) {
          this.paymentList[index].amount = total
          this.$set(this.paymentList, index, this.paymentList[index])
        }
      }
    },
    // 删除支付项
    handleDelete(index) {
      this.paymentList.splice(index, 1)
    },
    setData(list) {
      if (!list) return
      this.paymentList = []
      list.forEach((item) => {
        item.isHandle = !item.fixFlag
        item.type = item.payContent
        item.title = (this.settleMentFeeList.filter((v) => v.code === item.payContent)[0] || {}).name
        item.photos = Array.isArray(item.photos) ? item.photos : this.getURL({ data: item.photos, needName: true })
        this.paymentList.push(item)
      })
    },
    // 1. 支付款项：表格所有列之和
    paymentAmountCpt() {
      let paymentAmountSum = 0
      this.paymentList.forEach((item) => {
        paymentAmountSum += Number(item.amount)
      })
      this.paymentAmountSum = Number(paymentAmountSum.toFixed(2))
      this.$emit('amountChange', Number(paymentAmountSum.toFixed(2)))
    },
    // 处理提交需要的数据
    // eslint-disable-next-line vue/no-unused-properties
    getData() {
      const arr = this.paymentList.map((item) => {
        const itemPhotos = this.getUoloadCommonFileData(item.photos)
        return {
          payContent: item.type,
          sort: item.sort,
          amount: item.amount,
          remarks: item.remarks,
          photos: itemPhotos,
        }
      })
      return arr
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-table .cell{
  padding: 16px ;
}
</style>
